import styled from 'styled-components';

export const Container = styled.div`
  padding: 30px;
  margin: 30px;
  background-color: ${(props) => props.theme.backgroundLighter};
`;

export const LinkButton = styled.button<{ fontSize?: number; hover?: boolean }>`
  display: block;
  font-size: ${({ fontSize }) => fontSize || 16}px;
  margin-top: 10px;
  text-decoration: underline;
  color: ${(props) => props.theme.primary};

  ${({ hover, theme }) =>
    hover
      ? `
    &:hover {
      color: ${theme.backgroundMid};
    }
  `
      : ''}
`;
